import * as bootstrap from 'bootstrap';
import './js/spotify.js';
